import React from 'react'
import Navbar from '../Header/Navbar'
import HeroSection from '../HeroSection/HeroSection'
import AboutSection from '../AboutSection/AboutSection'
import ImpactNumbers from '../ImpactNumbers/ImpactNumbers'
import ServicesSection from '../ServicesSection/ServicesSection'
import ServiceMore from '../ServiceMore/ServiceMore'
import WhyChooseUs from '../WhyChooseUs/WhyChooseUs'
import TrustSectorsSection from '../TrustSectorsSection/TrustSectorsSection'
import Footer from '../Footer/Footer'
import ReviewsSection from '../ReviewSection/ReviewSection'


function DensatHome() {
    return (
        <div>
             <Navbar/>
   <HeroSection/>
   <AboutSection/>
   <ImpactNumbers/>
   <ServicesSection/>
   <ServiceMore/>
   
   <WhyChooseUs/>
 <TrustSectorsSection/>
 <ReviewsSection/>
   <Footer/>
   
        </div>
    )
}

export default DensatHome
